import script from "./ProductInfoComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductInfoComponents.vue?vue&type=script&setup=true&lang=js"

import "./ProductInfoComponents.vue?vue&type=style&index=0&id=017a9be9&lang=less"

const __exports__ = script;

export default __exports__